const updates = [
  {
    date: '08-01',
    title: '《长相思》更新至第28集',
    desc: '小夭身世之谜逐步揭开，涂山璟与相柳之间暗流涌动，剧情进入高潮阶段。',
    tag: '热播更新',
  },
  {
    date: '08-01',
    title: '《你比星光美丽》更新至第35集',
    desc: '纪星与韩廷感情线迎来关键转折，职场危机与爱情抉择交织。',
    tag: '最新剧集',
  },
  {
    date: '07-31',
    title: '《庆余年》第二季全集上线',
    desc: '范闲重返京都，朝堂风云再起，全36集一次放出，剧迷狂欢进行时。',
    tag: '重磅上线',
  },
  {
    date: '07-31',
    title: '《与凤行》全集39集完整上线',
    desc: '赵丽颖×林更新仙侠巨制，全部剧集高清放送，错过不再有。',
    tag: '全集上线',
  },
  {
    date: '07-30',
    title: '暑期片单全面更新',
    desc: '暑假档热门剧集集中上线，古装、都市、悬疑多品类全覆盖。',
    tag: '专题策划',
  },
  {
    date: '07-29',
    title: '画质全面升级至1080P',
    desc: '平台全站视频画质升级完成，所有剧集均可享受超高清观看体验。',
    tag: '平台升级',
  },
  {
    date: '07-28',
    title: '移动端体验优化完成',
    desc: '手机端播放流畅度提升30%，新增智能续播与夜间模式功能。',
    tag: '体验优化',
  },
  {
    date: '07-27',
    title: '韩剧专区新剧上线',
    desc: '多部热门韩剧高清版同步更新，字幕精准翻译，追韩剧更轻松。',
    tag: '新剧上线',
  },
  {
    date: '07-26',
    title: '经典老剧重温专题',
    desc: '《甄嬛传》《琅琊榜》等经典作品高清修复版上线，一键重温。',
    tag: '经典回顾',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-timer-flash-line text-accent-400 text-xs"></i>
            <span className="text-accent-300 text-xs font-medium">追剧快讯</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            最新更新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            每日同步最新剧集更新，追剧快讯一手掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14 pb-8 last:pb-0">
                <div className="absolute left-2.5 md:left-4 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-accent-500 bg-background-50 z-10"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="whitespace-nowrap text-xs font-bold text-accent-600 bg-accent-50 px-2.5 py-1 rounded-md self-start">
                    {item.date}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900">
                        {item.title}
                      </h3>
                      <span className="whitespace-nowrap px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[10px] font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}